export default __webpack_public_path__ + "static/media/two.7f3535cf.jpeg";